/**
 * UI Utilities
 * 
 * Functions for UI interactions (modals, popovers, etc.)
 */

import * as bootstrap from "bootstrap";

/**
 * Close a Bootstrap modal
 * @param {string} modalId - Modal element ID
 */
export function closeModal(modalId) {
  try {
    const modalEl = document.getElementById(modalId);
    const modal =
      bootstrap.Modal.getInstance(modalEl) ?? new bootstrap.Modal(modalEl);
    modal.hide();
  } catch (e) { }
}

/**
 * Open a Bootstrap modal
 * @param {string} modalId - Modal element ID
 */
export function openModal(modalId) {
  try {
    const modalEl = document.getElementById(modalId);
    const modal =
      bootstrap.Modal.getInstance(modalEl) ?? new bootstrap.Modal(modalEl);
    modal.show();
  } catch (e) { }
}

/**
 * Close a Bootstrap popover or dropdown
 * @param {string|HTMLElement} popoverEl - Popover element ID or element
 */
export function closePopover(popoverEl) {
  if (typeof popoverEl === 'string') {
    popoverEl = document.getElementById(popoverEl);
  }
  if (!popoverEl) return;

  const dropdown = bootstrap.Dropdown.getInstance(popoverEl);
  if (dropdown) {
    dropdown.hide();
    return;
  }

  const popover = bootstrap.Popover.getInstance(popoverEl) ?? new bootstrap.Popover(popoverEl);
  popover.hide();
}

